import { signInGoogle, signOutUser, watchAuth } from "./auth";
import { bindInteraction } from "./interact";
import { EditorScene } from "./scene";
import { shareIdFromUrl } from "./share";
import { store } from "./state";
import { bindUI } from "./ui";
import "./style.css";

const canvas = document.querySelector("canvas#view");
if (!(canvas instanceof HTMLCanvasElement)) throw new Error("Falta #view");

const editor = new EditorScene(canvas);
bindInteraction(editor);
bindUI(editor);

const authError = document.getElementById("auth-error");
const account = document.getElementById("account");
const userName = document.getElementById("user-name");
const userAvatar = document.getElementById("user-avatar") as HTMLImageElement | null;
const btnGoogle = document.getElementById("btn-google");
const btnLogout = document.getElementById("btn-logout");
const shareId = shareIdFromUrl();

btnGoogle?.addEventListener("click", async () => {
  try {
    if (authError) {
      authError.hidden = true;
      authError.textContent = "";
    }
    await signInGoogle();
  } catch (err) {
    if (authError) {
      authError.hidden = false;
      authError.textContent = err instanceof Error ? err.message : "No pude entrar con Google";
    }
  }
});

btnLogout?.addEventListener("click", () => {
  void signOutUser();
});

const startAuth = () => {
  watchAuth(async (user) => {
    document.body.classList.toggle("authed", Boolean(user));
    document.body.classList.remove("view-only");
    store.viewOnly = false;
    store.shareExpiresAt = null;
    if (account) account.hidden = !user;
    if (!user) {
      store.unbindUser();
      editor.rebuild();
      return;
    }
    if (userName) userName.textContent = user.name;
    if (userAvatar) {
      userAvatar.src = user.photo;
      userAvatar.hidden = !user.photo;
    }
    try {
      await store.bindUser(user.uid);
    } catch (err) {
      store.cloudError =
        err instanceof Error ? err.message : "Firestore no está listo. Publicá las reglas en Firebase.";
      store.notify();
    }
    editor.rebuild();
  });
};

if (shareId) {
  document.body.classList.add("authed", "view-only");
  if (account) account.hidden = false;
  void (async () => {
    try {
      await store.openShare(shareId);
      editor.rebuild();
    } catch {
      document.body.classList.remove("authed", "view-only");
      if (account) account.hidden = true;
      if (authError) {
        authError.hidden = false;
        authError.textContent = "Este enlace expiró o no existe.";
      }
      const card = document.querySelector(".auth-card p");
      if (card) card.textContent = "El enlace de vista ya no está disponible. Entrá con Google para abrir tus proyectos.";
      startAuth();
    }
  })();
} else {
  startAuth();
}

const loop = () => {
  editor.tick();
  requestAnimationFrame(loop);
};
loop();
